/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useCallback, useContext, useRef, useState, useEffect, useLayoutEffect } from 'react'
import { SettlementsList } from './Components/SettlementsSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useSearchParams } from 'react-router-dom'
import { dataService } from '../../services/data.services'
import Table from './Components/Table'
import GlobalContext from '../../components/Context/GlobalContext'
import Pagination from '../../components/Pagination'
import moment from 'moment'
import CardHeader from '../../components/CardHeader'
import SettlementsTopBar from './Components/SettlementsTopBar'

export default function CryptoSettlements(props) {
    const [isOpen, setIsOpen] = useState(false)
    const dependancy = useSelector(state => state.Dependancy)

    const { setToastmessage, toastErrorMessage, setToastErrorMessage, setToastError } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const Settlements = useSelector(state => state.Settlements);
    const { List, loading, error, } = Settlements;
    const [searchParams, setSearchParams] = useSearchParams({ });
    const [submitSelected, setSubmitSelected] = useState(false);
    const [exportloading, setExportloading] = useState(false);
    const [notFound, setNotFound] = useState(false);

    const [requiredAttention, setRequiredAttention] = useState(null);

    if (Object.keys(Object.fromEntries(searchParams)).length === 0) {
        setSearchParams({page_number:  1 });
    }

    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */

    const handleApplyFilter = (clear, year, month) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if (clear) {
            delete params.year
            delete params.month
            setSearchParams({ ...params })
            return
        }
        if (year !== '') {
            params.year = year
        } else {
            delete params.year
        }
        if(month !== ''){
            params.month = month
        }else{
            delete params.month
        }

        setSearchParams({ ...params })
    }

    const handleFilters = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        // params.filter = true
        if (key === 'all') {
            delete params['filter'];
            delete params['status'];
        }
        else params[key] = value
        setSearchParams({ ...params })
    }

    function objectToQueryString(obj) {
        const keys = Object.keys(obj);
        let str = ''
        const keyValuePairs = keys.map((key, i) => {
            str += `${i === 0 ? `?` : '&'}${encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])}`;
        });
        return str
        // more code goes here
    }

    useLayoutEffect(() => {
        let params = Object.fromEntries(searchParams);
        if(List?.data?.length !== 0 ){
            setNotFound(false);
            params.page_number = 1;
        }
        if (params?.attention) {
            setRequiredAttention(true);
        }else{
            setRequiredAttention(false);
        }
    },[List]);
    
    const GetList = useCallback(async () => {
        let params = Object.fromEntries(searchParams);
        delete params.tab
        try {
            params = objectToQueryString(params);
            dispatch(SettlementsList(params))
        } catch (error) {
            // handleLoadData()
            console.error(error);
        }
    }, [searchParams]);

    useEffect(() => {
        GetList();
    }, [GetList, dependancy])

    const handleExport = async () => {
        let params = Object.fromEntries(searchParams);
        delete params.page_number
        const body = { ...params }
        let search = ''
        search = searchParams.get('search');
        params = objectToQueryString(params);
        try{
            setExportloading(true);
            const res = await dataService.GetAPI(`settlements/export-csv${params}`)
            if (!res.error) {
                window.open(
                    res.data.url,
                    '_blank'
                );
                // window.location.href = res.data.url
                setToastmessage('Crypto Settlements exported successfully');
                setExportloading(false)
            }
        }catch(error){
            setToastError('An Error Occured!');
            setExportloading(false);
        }
    }

    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }
   
    useEffect(() => {
        if(error){
            if(error?.response?.status === 400){
                setNotFound(true);
            }else{
                setToastError('An Error Occured!');
            }
        }
    },[error])

    /// Dont remove the below code it is being used
    const param = Object.fromEntries(searchParams);

    useEffect(() => {
        
    },[]);

    useEffect(() => {
        const params = Object.fromEntries(searchParams);
        if(requiredAttention){
            params.attention = 'true'
            params.page_number = 1
        }else{
            delete params.attention
            params.page_number = 1
        }
        setSearchParams({ ...params })
    },[requiredAttention])

    return (
        <CardHeader header={'Settlements'} noIcon>
            <div className='bg-[#f5f5f5] px-[16px] py-[12px] mt-[110px] '>
                <div className='h-customh10 bg-white rounded'>
                    <>
                        <SettlementsTopBar
                            listLoading={loading}
                            requiredAttention={requiredAttention}
                            setRequiredAttention={setRequiredAttention}
                            notFound={notFound}
                            isFilter
                            searchText="Order Number, Email Address"
                            sidePane={setIsOpen}
                            handleFilters={handleFilters}
                            SearchValue={!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || ''}
                            searchParams={searchParams}
                            setSearchParams={setSearchParams}
                            handleApplyFilter={handleApplyFilter}
                            testid='add-btn'
                            setsubmitSelected={setSubmitSelected}
                            handleExport={handleExport}
                            exportloading={exportloading}
                        />
                        <div className='bg-white h-fit rounded-b'>
                            <Table
                                notFound={notFound}
                                error={error}
                                loading={loading}
                                searchParams={searchParams}
                            />
                        </div>
                        {!loading && Math.ceil(List.total_count / 10) > 1 && (!(List?.data?.length === 0 && !(param.search || param.status || param.payment_type || param.create_start || param.create_end))) &&
                        <Pagination selectedPageNumber={searchParams.get('page_number')} handleOnClickPageNumber={handleOnClickPageNumber} TotalCount={List.total_count} totalPageNumber={Math.ceil(List.total_count / 10)} />}
                    </>
                </div>
            </div>

        </CardHeader >
    )
}
